/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react'
import { ApolloProvider } from '@apollo/client/react'
import LogRocket from 'logrocket'
import ApolloClient from './src/clients/apollo'

const HEAP_APP_ID = '1378394995'

export const wrapRootElement = ({ element }) => (
    <ApolloProvider client={ApolloClient}>
        {element}
    </ApolloProvider>
)

export const onClientEntry = () => {
    LogRocket.init('wpmvs0/peterwiebecom');

    // Heap analytics loader snippet (replaces the unmaintained gatsby-plugin-heap)
    window.heap = window.heap || [];
    heap.load = function(e, t) {
        window.heap.appid = e; window.heap.config = t = t || {};
        var r = document.createElement("script");
        r.type = "text/javascript"; r.async = !0; r.src = "https://cdn.heapanalytics.com/js/heap-" + e + ".js";
        var a = document.getElementsByTagName("script")[0]; a.parentNode.insertBefore(r, a);
        var n = function(e) {
            return function() { heap.push([e].concat(Array.prototype.slice.call(arguments, 0))) }
        };
        var p = ["addEventProperties", "addUserProperties", "clearEventProperties", "identify", "resetIdentity", "removeEventProperty", "setEventProperties", "track", "unsetEventProperty"];
        for (var o = 0; o < p.length; o++) heap[p[o]] = n(p[o])
    };
    heap.load(HEAP_APP_ID);
}
